import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { swal } from '../utils/swal';
import './Operadores.css';

interface Remolque {
  id: number;
  placa: string;
  numero_interno?: string;
  tipo: string;
  marca?: string;
  modelo?: string;
  año?: number;
  color?: string;
  estado: string;
  // INFORMACION REMOLQUE
  alto?: number;
  ancho?: number;
  largo?: number;
  voladizo_posterior?: number;
  numero_ejes?: number;
  peso?: number;
  capacidad_toneladas?: number;
  capacidad_litros?: number;
  prop_trailer_nombre?: string;
  prop_trailer_nit?: string;
  prop_trailer_telefono?: string;
  // DATOS PROPIETARIO
  propietario_nombres?: string;
  propietario_numero_documento?: string;
  propietario_lugar_expedicion?: string;
  propietario_numero_cuenta?: string;
  propietario_tipo_cuenta?: string;
  propietario_ciudad?: string;
  propietario_direccion_residencia?: string;
  propietario_telefono_fijo?: string;
  propietario_celular?: string;
  // DATOS DEL POSEEDOR
  poseedor_nombres?: string;
  poseedor_numero_documento?: string;
  poseedor_lugar_expedicion?: string;
  poseedor_tipo_cuenta?: string;
  poseedor_banco?: string;
  poseedor_ciudad?: string;
  poseedor_direccion_residencia?: string;
  poseedor_telefono_fijo?: string;
  poseedor_celular?: string;
}

const Remolques: React.FC = () => {
  const [remolques, setRemolques] = useState<Remolque[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showCrearModal, setShowCrearModal] = useState(false);
  const [showEditarModal, setShowEditarModal] = useState(false);
  const [remolqueEditando, setRemolqueEditando] = useState<Remolque | null>(null);
  const [formData, setFormData] = useState({
    // Básicos
    placa: '',
    numero_interno: '',
    tipo: 'cisterna',
    marca: '',
    modelo: '',
    año: '',
    color: '',
    capacidad_litros: '',
    numero_serie: '',
    // INFORMACION REMOLQUE
    alto: '',
    ancho: '',
    largo: '',
    voladizo_posterior: '',
    numero_ejes: '',
    peso: '',
    capacidad_toneladas: '',
    prop_trailer_nombre: '',
    prop_trailer_nit: '',
    prop_trailer_telefono: '',
    // DATOS PROPIETARIO
    propietario_nombres: '',
    propietario_numero_documento: '',
    propietario_lugar_expedicion: '',
    propietario_numero_cuenta: '',
    propietario_tipo_cuenta: 'AHORROS',
    propietario_ciudad: '',
    propietario_direccion_residencia: '',
    propietario_telefono_fijo: '',
    propietario_celular: '',
    // DATOS DEL POSEEDOR
    poseedor_nombres: '',
    poseedor_numero_documento: '',
    poseedor_lugar_expedicion: '',
    poseedor_tipo_cuenta: 'AHORROS',
    poseedor_banco: '',
    poseedor_ciudad: '',
    poseedor_direccion_residencia: '',
    poseedor_telefono_fijo: '',
    poseedor_celular: ''
  });

  useEffect(() => {
    loadRemolques();
  }, []);

  const loadRemolques = async () => {
    try {
      setLoading(true);
      const response = await api.get('/remolques', {
        params: { limit: 100, ...(search && { search }) },
      });
      setRemolques(response.data.data || []);
    } catch (error) {
      console.error('Error cargando remolques:', error);
      await swal.error('Error al cargar remolques');
    } finally {
      setLoading(false);
    }
  };

  const abrirCrear = () => {
    setFormData({
      placa: '',
      numero_interno: '',
      tipo: 'cisterna',
      marca: '',
      modelo: '',
      año: '',
      color: '',
      capacidad_litros: '',
      numero_serie: '',
      alto: '',
      ancho: '',
      largo: '',
      voladizo_posterior: '',
      numero_ejes: '',
      peso: '',
      capacidad_toneladas: '',
      prop_trailer_nombre: '',
      prop_trailer_nit: '',
      prop_trailer_telefono: '',
      propietario_nombres: '',
      propietario_numero_documento: '',
      propietario_lugar_expedicion: '',
      propietario_numero_cuenta: '',
      propietario_tipo_cuenta: 'AHORROS',
      propietario_ciudad: '',
      propietario_direccion_residencia: '',
      propietario_telefono_fijo: '',
      propietario_celular: '',
      poseedor_nombres: '',
      poseedor_numero_documento: '',
      poseedor_lugar_expedicion: '',
      poseedor_tipo_cuenta: 'AHORROS',
      poseedor_banco: '',
      poseedor_ciudad: '',
      poseedor_direccion_residencia: '',
      poseedor_telefono_fijo: '',
      poseedor_celular: ''
    });
    setShowCrearModal(true);
  };

  const abrirEditar = async (remolque: Remolque) => {
    setRemolqueEditando(remolque);
    setFormData({
      placa: remolque.placa || '',
      numero_interno: remolque.numero_interno || '',
      tipo: remolque.tipo || 'cisterna',
      marca: remolque.marca || '',
      modelo: remolque.modelo || '',
      año: remolque.año?.toString() || '',
      color: remolque.color || '',
      capacidad_litros: remolque.capacidad_litros?.toString() || '',
      numero_serie: '',
      alto: remolque.alto?.toString() || '',
      ancho: remolque.ancho?.toString() || '',
      largo: remolque.largo?.toString() || '',
      voladizo_posterior: remolque.voladizo_posterior?.toString() || '',
      numero_ejes: remolque.numero_ejes?.toString() || '',
      peso: remolque.peso?.toString() || '',
      capacidad_toneladas: remolque.capacidad_toneladas?.toString() || '',
      prop_trailer_nombre: remolque.prop_trailer_nombre || '',
      prop_trailer_nit: remolque.prop_trailer_nit || '',
      prop_trailer_telefono: remolque.prop_trailer_telefono || '',
      propietario_nombres: remolque.propietario_nombres || '',
      propietario_numero_documento: remolque.propietario_numero_documento || '',
      propietario_lugar_expedicion: remolque.propietario_lugar_expedicion || '',
      propietario_numero_cuenta: remolque.propietario_numero_cuenta || '',
      propietario_tipo_cuenta: remolque.propietario_tipo_cuenta || 'AHORROS',
      propietario_ciudad: remolque.propietario_ciudad || '',
      propietario_direccion_residencia: remolque.propietario_direccion_residencia || '',
      propietario_telefono_fijo: remolque.propietario_telefono_fijo || '',
      propietario_celular: remolque.propietario_celular || '',
      poseedor_nombres: remolque.poseedor_nombres || '',
      poseedor_numero_documento: remolque.poseedor_numero_documento || '',
      poseedor_lugar_expedicion: remolque.poseedor_lugar_expedicion || '',
      poseedor_tipo_cuenta: remolque.poseedor_tipo_cuenta || 'AHORROS',
      poseedor_banco: remolque.poseedor_banco || '',
      poseedor_ciudad: remolque.poseedor_ciudad || '',
      poseedor_direccion_residencia: remolque.poseedor_direccion_residencia || '',
      poseedor_telefono_fijo: remolque.poseedor_telefono_fijo || '',
      poseedor_celular: remolque.poseedor_celular || ''
    });
    setShowEditarModal(true);
  };

  const guardarRemolque = async () => {
    try {
      const dataToSend: any = {
        ...formData,
        año: formData.año ? parseInt(formData.año) : null,
        capacidad_litros: formData.capacidad_litros ? parseFloat(formData.capacidad_litros) : null,
        alto: formData.alto ? parseFloat(formData.alto) : null,
        ancho: formData.ancho ? parseFloat(formData.ancho) : null,
        largo: formData.largo ? parseFloat(formData.largo) : null,
        voladizo_posterior: formData.voladizo_posterior ? parseFloat(formData.voladizo_posterior) : null,
        numero_ejes: formData.numero_ejes ? parseInt(formData.numero_ejes) : null,
        peso: formData.peso ? parseFloat(formData.peso) : null,
        capacidad_toneladas: formData.capacidad_toneladas ? parseFloat(formData.capacidad_toneladas) : null
      };

      if (remolqueEditando) {
        await api.put(`/remolques/${remolqueEditando.id}`, dataToSend);
        await swal.success('Remolque actualizado correctamente');
      } else {
        await api.post('/remolques', dataToSend);
        await swal.success('Remolque creado correctamente');
      }
      
      setShowCrearModal(false);
      setShowEditarModal(false);
      setRemolqueEditando(null);
      loadRemolques();
    } catch (error: any) {
      await swal.error(error.response?.data?.error || 'Error al guardar remolque');
    }
  };

  const renderFormulario = () => (
    <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
      <div className="form-grid">
        {/* INFORMACION REMOLQUE */}
        <div className="form-section">
          <h3 style={{ gridColumn: '1 / -1', marginBottom: '15px', color: '#333', borderBottom: '2px solid #007bff', paddingBottom: '10px' }}>
            📋 INFORMACION REMOLQUE
          </h3>
          
          <div className="form-group">
            <label>Placa (Trayler) *</label>
            <input
              type="text"
              value={formData.placa}
              onChange={(e) => setFormData({ ...formData, placa: e.target.value.toUpperCase() })}
              required
              disabled={!!remolqueEditando}
            />
          </div>

          <div className="form-group">
            <label>Marca *</label>
            <input
              type="text"
              value={formData.marca}
              onChange={(e) => setFormData({ ...formData, marca: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label>Color</label>
            <input
              type="text"
              value={formData.color}
              onChange={(e) => setFormData({ ...formData, color: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Modelo (Año)</label>
            <input
              type="number"
              value={formData.año}
              onChange={(e) => setFormData({ ...formData, año: e.target.value })}
              min="1900"
              max="2100"
            />
          </div>

          <div className="form-group">
            <label>Alto (m)</label>
            <input
              type="number"
              step="0.01"
              value={formData.alto}
              onChange={(e) => setFormData({ ...formData, alto: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Ancho (m)</label>
            <input
              type="number"
              step="0.01"
              value={formData.ancho}
              onChange={(e) => setFormData({ ...formData, ancho: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Largo (m)</label>
            <input
              type="number"
              step="0.01"
              value={formData.largo}
              onChange={(e) => setFormData({ ...formData, largo: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Voladizo Posterior (m)</label>
            <input
              type="number"
              step="0.01"
              value={formData.voladizo_posterior}
              onChange={(e) => setFormData({ ...formData, voladizo_posterior: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>No. Ejes</label>
            <input
              type="number"
              value={formData.numero_ejes}
              onChange={(e) => setFormData({ ...formData, numero_ejes: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Peso (kg)</label>
            <input
              type="number"
              step="0.01"
              value={formData.peso}
              onChange={(e) => setFormData({ ...formData, peso: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Capacidad Diseño (TN)</label>
            <input
              type="number"
              step="0.01"
              value={formData.capacidad_toneladas}
              onChange={(e) => setFormData({ ...formData, capacidad_toneladas: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Capacidad (Litros)</label>
            <input
              type="number"
              step="0.01"
              value={formData.capacidad_litros}
              onChange={(e) => setFormData({ ...formData, capacidad_litros: e.target.value })}
            />
          </div>

          <div className="form-group full-width">
            <label>Prop Trailer (Nombre Empresa)</label>
            <input
              type="text"
              value={formData.prop_trailer_nombre}
              onChange={(e) => setFormData({ ...formData, prop_trailer_nombre: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>No. C.C (NIT)</label>
            <input
              type="text"
              value={formData.prop_trailer_nit}
              onChange={(e) => setFormData({ ...formData, prop_trailer_nit: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Fijo/Cel</label>
            <input
              type="text"
              value={formData.prop_trailer_telefono}
              onChange={(e) => setFormData({ ...formData, prop_trailer_telefono: e.target.value })}
            />
          </div>
        </div>

        {/* DATOS PROPIETARIO */}
        <div className="form-section" style={{ marginTop: '30px' }}>
          <h3 style={{ gridColumn: '1 / -1', marginBottom: '15px', color: '#333', borderBottom: '2px solid #28a745', paddingBottom: '10px' }}>
            👤 DATOS PROPIETARIO
          </h3>

          <div className="form-group full-width">
            <label>Nombres Y Apellidos</label>
            <input
              type="text"
              value={formData.propietario_nombres}
              onChange={(e) => setFormData({ ...formData, propietario_nombres: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>No. C.C.</label>
            <input
              type="text"
              value={formData.propietario_numero_documento}
              onChange={(e) => setFormData({ ...formData, propietario_numero_documento: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Lugar de Exp.</label>
            <input
              type="text"
              value={formData.propietario_lugar_expedicion}
              onChange={(e) => setFormData({ ...formData, propietario_lugar_expedicion: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>No de Cta</label>
            <input
              type="text"
              value={formData.propietario_numero_cuenta}
              onChange={(e) => setFormData({ ...formData, propietario_numero_cuenta: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Tipo Cta</label>
            <select
              value={formData.propietario_tipo_cuenta}
              onChange={(e) => setFormData({ ...formData, propietario_tipo_cuenta: e.target.value })}
            >
              <option value="AHORROS">Ahorros</option>
              <option value="CORRIENTE">Corriente</option>
            </select>
          </div>

          <div className="form-group">
            <label>Ciudad</label>
            <input
              type="text"
              value={formData.propietario_ciudad}
              onChange={(e) => setFormData({ ...formData, propietario_ciudad: e.target.value })}
            />
          </div>

          <div className="form-group full-width">
            <label>Dirección Residencia</label>
            <input
              type="text"
              value={formData.propietario_direccion_residencia}
              onChange={(e) => setFormData({ ...formData, propietario_direccion_residencia: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Tel Fijo</label>
            <input
              type="text"
              value={formData.propietario_telefono_fijo}
              onChange={(e) => setFormData({ ...formData, propietario_telefono_fijo: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Cel</label>
            <input
              type="text"
              value={formData.propietario_celular}
              onChange={(e) => setFormData({ ...formData, propietario_celular: e.target.value })}
            />
          </div>
        </div>

        {/* DATOS DEL POSEEDOR */}
        <div className="form-section" style={{ marginTop: '30px' }}>
          <h3 style={{ gridColumn: '1 / -1', marginBottom: '15px', color: '#333', borderBottom: '2px solid #ffc107', paddingBottom: '10px' }}>
            🏢 DATOS DEL POSEEDOR
          </h3>

          <div className="form-group full-width">
            <label>Nombres Y Apellidos</label>
            <input
              type="text"
              value={formData.poseedor_nombres}
              onChange={(e) => setFormData({ ...formData, poseedor_nombres: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>No. C.C. (NIT)</label>
            <input
              type="text"
              value={formData.poseedor_numero_documento}
              onChange={(e) => setFormData({ ...formData, poseedor_numero_documento: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Lugar de Exp.</label>
            <input
              type="text"
              value={formData.poseedor_lugar_expedicion}
              onChange={(e) => setFormData({ ...formData, poseedor_lugar_expedicion: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Tipo Cta</label>
            <select
              value={formData.poseedor_tipo_cuenta}
              onChange={(e) => setFormData({ ...formData, poseedor_tipo_cuenta: e.target.value })}
            >
              <option value="AHORROS">Ahorros</option>
              <option value="CORRIENTE">Corriente</option>
            </select>
          </div>

          <div className="form-group">
            <label>Banco</label>
            <input
              type="text"
              value={formData.poseedor_banco}
              onChange={(e) => setFormData({ ...formData, poseedor_banco: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Ciudad</label>
            <input
              type="text"
              value={formData.poseedor_ciudad}
              onChange={(e) => setFormData({ ...formData, poseedor_ciudad: e.target.value })}
            />
          </div>

          <div className="form-group full-width">
            <label>Dirección Residencia</label>
            <input
              type="text"
              value={formData.poseedor_direccion_residencia}
              onChange={(e) => setFormData({ ...formData, poseedor_direccion_residencia: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Tel Fijo</label>
            <input
              type="text"
              value={formData.poseedor_telefono_fijo}
              onChange={(e) => setFormData({ ...formData, poseedor_telefono_fijo: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Cel</label>
            <input
              type="text"
              value={formData.poseedor_celular}
              onChange={(e) => setFormData({ ...formData, poseedor_celular: e.target.value })}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>🚚 Remolques</h1>
        <button onClick={abrirCrear} className="btn-primary">
          ➕ Nuevo Remolque
        </button>
      </div>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Buscar por placa o número interno..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && loadRemolques()}
        />
        <button onClick={loadRemolques} className="btn-secondary">
          🔍 Buscar
        </button>
      </div>

      {loading ? (
        <div className="loading">Cargando...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Placa</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>Año</th>
                <th>Color</th>
                <th>Tipo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {remolques.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ textAlign: 'center', padding: '20px' }}>
                    No hay remolques registrados
                  </td>
                </tr>
              ) : (
                remolques.map((remolque) => (
                  <tr key={remolque.id}>
                    <td>{remolque.placa}</td>
                    <td>{remolque.marca || '-'}</td>
                    <td>{remolque.modelo || '-'}</td>
                    <td>{remolque.año || '-'}</td>
                    <td>{remolque.color || '-'}</td>
                    <td>{remolque.tipo}</td>
                    <td>
                      <span className={`badge badge-${remolque.estado}`}>
                        {remolque.estado}
                      </span>
                    </td>
                    <td>
                      <button
                        onClick={() => abrirEditar(remolque)}
                        className="btn-link"
                        title="Editar remolque"
                      >
                        ✏️ Editar
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal Crear */}
      {showCrearModal && (
        <div className="modal-overlay" onClick={() => setShowCrearModal(false)}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Crear Nuevo Remolque</h2>
              <button className="modal-close" onClick={() => setShowCrearModal(false)}>✕</button>
            </div>
            {renderFormulario()}
            <div className="modal-actions">
              <button onClick={guardarRemolque} className="btn-primary">💾 Guardar</button>
              <button onClick={() => setShowCrearModal(false)} className="btn-secondary">Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar */}
      {showEditarModal && remolqueEditando && (
        <div className="modal-overlay" onClick={() => setShowEditarModal(false)}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Editar Remolque - {remolqueEditando.placa}</h2>
              <button className="modal-close" onClick={() => setShowEditarModal(false)}>✕</button>
            </div>
            {renderFormulario()}
            <div className="modal-actions">
              <button onClick={guardarRemolque} className="btn-primary">💾 Guardar Cambios</button>
              <button onClick={() => setShowEditarModal(false)} className="btn-secondary">Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Remolques;


